// components/layout/Footer/styles.js
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Container } from "../../../styles/components";

export const FooterWrapper = styled.footer`
	background: ${(props) => props.theme.colors.background.alt};
	padding: ${(props) => `${props.theme.spacing["4xl"]} 0`};
	margin-top: auto;
`;

export const FooterContainer = styled(Container)`
	display: grid;
	grid-template-columns: repeat(1, 1fr);
	gap: ${(props) => props.theme.spacing.xl};

	@media (min-width: ${(props) => props.theme.breakpoints.sm}) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (min-width: ${(props) => props.theme.breakpoints.lg}) {
		grid-template-columns: 2fr repeat(3, 1fr);
	}
`;

export const FooterSection = styled.div`
	h3 {
		font-size: ${(props) => props.theme.typography.sizes.lg};
		font-weight: ${(props) => props.theme.typography.weights.bold};
		color: ${(props) => props.theme.colors.text.primary};
		margin-bottom: ${(props) => props.theme.spacing.lg};
	}

	p {
		color: ${(props) => props.theme.colors.text.secondary};
		font-size: ${(props) => props.theme.typography.sizes.md};
		margin-bottom: ${(props) => props.theme.spacing.md};
		max-width: 300px;
	}
`;

export const FooterList = styled.ul`
	list-style: none;
	padding: 0;
	margin: 0;
`;

export const FooterLink = styled(Link)`
	display: block;
	color: ${(props) => props.theme.colors.text.secondary};
	font-size: ${(props) => props.theme.typography.sizes.md};
	padding: ${(props) => `${props.theme.spacing.xs} 0`};
	transition: color ${(props) => props.theme.transitions.fast};

	&:hover {
		color: ${(props) => props.theme.colors.primary.main};
	}

	
`;

export const SocialLinks = styled.div`
	display: flex;
	gap: ${(props) => props.theme.spacing.md};
	margin-top: ${(props) => props.theme.spacing.lg};
`;

export const SocialLink = styled.a`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	border-radius: ${(props) => props.theme.borderRadius.full};
	background: ${(props) => props.theme.colors.background.main};
	color: ${(props) => props.theme.colors.text.secondary};
	transition: all ${(props) => props.theme.transitions.fast};

	&:hover {
		background: ${(props) => props.theme.colors.primary.main};
		color: ${(props) => props.theme.colors.primary.contrast};
	}
`;

export const BottomBar = styled.div`
	border-top: 1px solid ${(props) => props.theme.colors.text.disabled}20;
	margin-top: ${(props) => props.theme.spacing.xxl};
	padding-top: ${(props) => props.theme.spacing.xl};
	text-align: center;
	color: ${(props) => props.theme.colors.text.secondary};
	font-size: ${(props) => props.theme.typography.sizes.sm};
`;
